<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import axios from "axios";
    import { EmojiPicker } from "../lib/ui";
    import { createEventDispatcher } from 'svelte';
    
    export let bot;
    export let scenario;

    let refScenarioContext;
    let clickFlag = false;
    const dispatch = createEventDispatcher();

    onMount(() => {
    });

    const onEmoji = (e) => {
        changeCharacterDialog(e.detail, true);
    }
    // 변경 이벤트 체크, 클릭해야 마우스 아웃될 때 로직수행
    const changeCharacterDialog = (addedContext = "", typing) => {
        const charMent = refScenarioContext.value.slice(0, refScenarioContext.selectionEnd) + addedContext + refScenarioContext.value.slice(refScenarioContext.selectionEnd);
        bot.defaultChar.activeScenario.changeCharMent(charMent);
    }
    // 클릭 하면 active시나리오 변경되도록 컴포넌트 정의하는 부분에 click이벤트 체크
    const onClickContext = () => {
        clickFlag = true;
        dispatch('click', {
            text: 'click event'
        });
    }
    // 매번 변경사항을 리로드x, 줄이 바뀔 때 변경되도록
    const handleCharacterDialog = (e) => {
        const originRows = scenario.getCharMentRows();
        const currentRows = refScenarioContext.value.split("\n").length;
        if (originRows != currentRows) {
            changeCharacterDialog("", true);
        }
    }

</script>
<div class="talk-title">
    <div class="description-input">
        <div class="description-input-form w-form">
            <div id="email-form" class="talk-form" on:click={onClickContext}>
                <textarea class="name-text-form story w-input" rows={scenario.getCharMentRows()} value={scenario.charMent} bind:this={refScenarioContext} on:change={()=>changeCharacterDialog()} autofocus="true" maxlength="256" name="name-4" data-name="Name 4" placeholder="내용을 입력해주세요!" id="name-4" on:input={handleCharacterDialog} />
                <EmojiPicker on:emoji={onEmoji} />
            </div>
        </div>
    </div>
</div>

<style>
    .description-input-form {
        width: 100%;
        height: auto;
    }

    .talk-form {
        width: 340px;
        height: auto;
        text-align: left;
        margin: auto;
        border-style: none;
        border-radius: none;
        /* 흰색 하드코딩 → 투명. 다크모드에서 상위 카드(--sb-card) 배경이 비쳐 흰 패치 방지 */
        background-color: transparent;
		padding-top: 8px;
    	padding-bottom: 8px;
	}

    .name-text-form.story::placeholder {
        color: #8f8f8f;
        font-weight: 400;
    }

	.name-text-form {
		font-size: 16px;
	}
</style>